import { render, staticRenderFns } from "./orderSet.vue?vue&type=template&id=ddb55326&scoped=true&"
import script from "./orderSet.vue?vue&type=script&lang=js&"
export * from "./orderSet.vue?vue&type=script&lang=js&"
import style0 from "./orderSet.vue?vue&type=style&index=0&id=ddb55326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb55326",
  null
  
)

export default component.exports